import { DollarSign } from "react-feather";
import ShoppingIcon from "../../../Components/Common/svg/shoppingicon";
import RefreshIcon from "../../../Components/Common/svg/reports/refreshicon";
import MoneyBagIcon from "../../../Components/Common/svg/reports/moneybagicon";
import CheckMarkIcon from "../../../Components/Common/svg/checkMark";
import { formatPrice } from "../../../utils/formatPrice";

export const tabs = [
  { id: 3, label: "account", name: "الحساب" },
  { id: 4, label: "location", name: "معلومات الموقع" },
  { id: 5, label: "workingDays", name: "مواعيد العمل" },
    { id: 6, label: "attendance", name: "الجضور" },
  { id: 7, label: "orders", name: "التوصيلات" },
  { id: 2, label: "wallet", name: " المحفظة" },
  { id: 1, label: "attachments", name: "الوثائق" },

  ,
];


export const CuriorStatsConfig = (stats, factor) => [
  {
    title: "إجمالي التسليمات",
    count: stats?.total_deliveries,
    color: "#FFCC03",
    icon:  <ShoppingIcon color="#FFCC03" />,
    bgIcon: "#E6F3EF",  
  },
  {    
    title: "الطلبات المكتملة",
    count: stats?.completed_orders,
    color: "#003726",
    icon: <CheckMarkIcon/>,
    bgIcon: "#8AC6B4",
  },
  {
    title: "الطلبات الملغاه",
    count: stats?.cancelled_orders,
    color: "#FF3B30",
    icon: <RefreshIcon  />,
    bgIcon: "#FDEAE9",
  },
  {
    title: "الأرباح",
    count: formatPrice(factor, stats?.total_earnings),
    color: "#FC0",
    icon: <MoneyBagIcon />,
    bgIcon: "#FFF7BA",
  },
  {
    title: "رصيد المحفظة",
    count: formatPrice(factor, stats?.wallet_balance),
    color: "#0F2B42",
    icon: <DollarSign/>,
    bgIcon: "#E7EAEC",
  },
];